import React from 'react';
import { AgPledgeCertificateCompanyRegistered } from '@indigo-ag/schema';
import { Fieldset } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { GridContainer, GridContainerItem, parseNumberToLocale, utils } from 'shared';

interface PledgeCertificateRegisteredCompanySummaryProps {
  title: string;
  companyInfo?: AgPledgeCertificateCompanyRegistered;
}

export const PledgeCertificateRegisteredCompanySummary: React.FunctionComponent<PledgeCertificateRegisteredCompanySummaryProps> = ({
  title,
  companyInfo
}) => {
  const items: GridContainerItem[] = [
    {
      label: utils.text.toTitleCase(i18next.t('creditor')),
      value: companyInfo?.creditor
    },
    {
      label: utils.text.toTitleCase(i18next.t('emitter')),
      value: companyInfo?.emitter
    },
    {
      label: utils.text.toTitleCase(i18next.t('volumeBags')),
      value: parseNumberToLocale(companyInfo?.volume)
    },
    {
      label: utils.text.toTitleCase(i18next.t('pledgeArea')),
      value: parseNumberToLocale(companyInfo?.pledgeArea)
    },
    {
      label: utils.text.toTitleCase(i18next.t('matricula')),
      value: companyInfo?.matricula
    },
    {
      label: utils.text.toTitleCase(i18next.t('additionalInformation')),
      value: companyInfo?.additionalInformation
    }
  ];

  return (
    <Fieldset label={utils.text.toTitleCase(title)}>
      <GridContainer columns={3} items={items} />
    </Fieldset>
  );
};
